import { AxiosRequestConfig } from 'axios';
import { ReduxStore } from 'store/store';

const isRequestInWhitelist = (config: AxiosRequestConfig) => {
  // Check if the request URL matches any of the whitelisted patterns for Product Details API, Autosuggest API, or Availability API
  const patterns = [/\/v4\/byPartNumber/, /\/v1\/suggest/, /\/v1\/products/, /\/availability\./];

  if (patterns.some((pattern) => pattern.test(config.url ?? ''))) {
    return true;
  }

  return false;
};

export const onAxiosRequest = (config: AxiosRequestConfig, store: ReduxStore) => {
  if (!isRequestInWhitelist(config)) {
    // Request is not in the whitelist, return the config as is
    return config;
  }

  const headers = store.getState().common.headersToForward;
  const modifiedConfig = { ...config };
  modifiedConfig.headers = { ...headers, ...modifiedConfig.headers };
  return modifiedConfig;
};

export const onAxiosRequestError = (error: Error) => {
  console.error('Request error:', error);
  return Promise.reject(new Error('Request error'));
};
